/**
 * La recherche d'un compte, par ce qu'on en sait : un nom, un prénom, une
 * adresse courriel, une organisation, une localité, un téléphone.
 *
 * ## Un filtre par mot
 *
 * « Marie Dupont » ne figure dans aucune colonne : le prénom en porte la
 * moitié, le nom l'autre. Chaque mot devient donc un `or` sur toutes les
 * colonnes, et PostgREST combine plusieurs `or` par un ET : le compte doit
 * contenir chacun des mots, quelque part.
 *
 * Les caractères que PostgREST lit comme de la syntaxe sont retirés
 * (`nettoyerPourIlike`, la règle déjà tenue pour les factures).
 */

import { nettoyerPourIlike } from '../factures/recherche';

export const COLONNES_CHERCHEES = [
  'nom', 'prenom', 'email', 'organisation_name', 'localite', 'telephone',
] as const;

/** Au-delà, les mots suivants sont ignorés : une recherche n'a pas besoin de dix critères. */
export const MOTS_MAX = 4;

export function filtresDeRecherche(saisie: string | null | undefined): string[] {
  const propre = nettoyerPourIlike(saisie ?? '');
  if (propre === '') return [];
  return propre
    .split(' ')
    .filter((m) => m !== '')
    .slice(0, MOTS_MAX)
    .map((mot) => COLONNES_CHERCHEES.map((c) => `${c}.ilike.%${mot}%`).join(','));
}
